module.exports = __webpack_public_path__ + "img/baogao.76f792c3.png";